module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body--wrapper",
    attrs: {
      "id": "IndexApplyproject"
    }
  }, [_c('section', {
    staticClass: "section--wrapper"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('form', {
    attrs: {
      "action": ""
    }
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('p', {
    class: {
      'control': true
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    class: {
      'form-control': true,
      'is-danger': _vm.errors.has('email')
    },
    attrs: {
      "name": "email",
      "type": "text",
      "placeholder": "Email"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("\n                      " + _vm._s(_vm.errors.first('email')) + "\n                    ")])])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8)])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "title--top"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n              formulir apply project\n            ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "#"
    }
  }, [_vm._v("Nama Lengkap")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "#"
    }
  }, [_vm._v("Website URL")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "#"
    }
  }, [_vm._v("Dapat dari mana info kami")]), _vm._v(" "), _c('select', {
    staticClass: "form-control",
    attrs: {
      "name": "",
      "id": ""
    }
  }, [_c('option', {
    attrs: {
      "value": "#"
    }
  }, [_vm._v("Pilih salah satu")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#"
    }
  }, [_vm._v("Internet")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#"
    }
  }, [_vm._v("Google")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#"
    }
  }, [_vm._v("Teman")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "#"
    }
  }, [_vm._v("Telepon")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "#"
    }
  }, [_vm._v("Plan to Start")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    attrs: {
      "for": "#"
    }
  }, [_vm._v("Pesan anda")]), _vm._v(" "), _c('textarea', {
    staticClass: "form-control",
    attrs: {
      "name": "",
      "id": "",
      "cols": "30",
      "rows": "10"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    attrs: {
      "for": "#"
    }
  }, [_vm._v("Masukan Dokumen anda")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('br'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-danger",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-send"
  }), _vm._v("\n                    Kirim\n                  ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75b79e9d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/applyproject/IndexApplyproject.vue
// module id = 82
// module chunks = 0